import React, { useState } from "react";

const Toggle = ({ isOn , setIsOn, heading, initialState , containerClassName = "" }) => {

	const handleToggle = () => {
		setIsOn(!isOn);
	};

	return (
		<div className={`toggle-container gap-3 ${containerClassName}`}>
			<h4 className="main-heading-font level-6">{heading}</h4>
			<div
				className={`toggle-switch ${isOn ? "on" : "off"}`}
				onClick={handleToggle}
			>
				<div className="toggle-knob"></div>
			</div>
		</div>
	);
};

export default Toggle;
